import { get } from 'lodash';
import { delay, filter, mapTo, mergeMap } from 'rxjs/operators';
import { CUSTOM_FLASH_MESSAGE, DISMISS, ERROR_FLASH_MESSAGE, SUCCESS_FLASH_MESSAGE } from './index';
import { ofType } from 'redux-observable';
import { showBlockedFailedPaymentPopups } from '@helpers/payment';
import { Observable } from 'rxjs';
import { failedPaymentBannerPayload } from 'scenes/Dashboard/V2/Dashboard';

const autoDismissActions = [ERROR_FLASH_MESSAGE, SUCCESS_FLASH_MESSAGE];

export const dismissFlashEpic = (action$, store) => {
  return action$.pipe(
    filter(action => autoDismissActions.includes(action.type)),
    mapTo({
      type: DISMISS,
      payload: { autoDismiss: true },
    }),
    delay(10000)
  );
};

export const rollbackBlockedForPaymentBanner = (action$, store) => {
  return action$.pipe(
    ofType(DISMISS),
    mergeMap(action => {
      const state = store.getState();
      const user = state.session.currentUser;
      const autoDismiss = get(action, 'payload.autoDismiss');

      if (showBlockedFailedPaymentPopups(user) && autoDismiss) {
        return Observable.of({
          type: CUSTOM_FLASH_MESSAGE,
          payload: failedPaymentBannerPayload,
        });
      }

      return Observable.empty();
    })
  );
};
